/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AddPersonRelation from './AddPersonRelation/index'
import Addresses from './Addresses/index'
import Emails from './Emails/index'
import Phones from './Phones/index'
import ProfileData from './ProfileData/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<AddPersonRelation
  viewPath={`${viewPath}/AddPersonRelation`}
/>
<button
  data-testid="Profile.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'AddPersonRelation/Content'))}
 {...isHoveredBind}
 style={{'--mt-1-1AREyJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Profile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ProfileData
  viewPath={`${viewPath}/ProfileData`}
/>
<div
  data-testid="Profile.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<Addresses
  viewPath={`${viewPath}/Addresses`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}